import React from 'react';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * 
 *
 * // render
 * 
 */
export const IvrGetPin = ( props ) => {
    const { data } = props
    return (
        <div className='ui-ivrgetpin'>
            <div className='ui-ivrgetpin__header'>

                {/* title for the modal */}
                <div className='ui-ivrgetpin__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

             {/* For getting pin */}
			<div className='ui-ivrgetpin__body' onScroll={ props.onScroll }>

                <div className='ui-ivrgetpin__body__pin'> 
                { data.pin }
                 </div>
                
            </div>
        </div>
    );
};

// set display name
IvrGetPin.displayName = 'IvrGetPin';

// set default props
IvrGetPin.defaultProps = {};

// prop types
IvrGetPin.propTypes = {};
